import "./interface.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import urlUtils from "../../utils/urlUtils";
import Icon from "./Icon";

class Image extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { loadFailed: false };
    this.imageLoaded = this.imageLoaded.bind(this);
    this.imageFailed = this.imageFailed.bind(this);
  }

  imageLoaded() {
    this.setState({ loadFailed: false });
  }

  imageFailed() {
    this.setState({ loadFailed: true });
  }

  render() {
    // Encode the URI for use in the css url() value
    const encodedUrl = urlUtils.encodeUriIfRequired(this.props.source);

    const imageStyle = {
      backgroundImage: `url(${encodedUrl})`,
      backgroundSize: this.props.fill ? "cover" : "contain"
    };

    return (
      <div
        className={`imageWrapper ${this.props.showMissingLabel && this.state.loadFailed ? "showMissingLabel" : ""} ${
          this.props.className ? this.props.className : ""
        }`}
      >
        <div
          className="imageBackground"
          style={imageStyle}
          alt={this.props.alt ? this.props.alt : "An image"}
          onClick={this.props.onClick}
          onDoubleClick={this.props.onDoubleClick}
        >
          {/* The source need to encode the # syntax */}
          <img src={this.props.source.replace(/#/g, "%23")} onLoad={this.imageLoaded} onError={this.imageFailed} />
          {this.state.loadFailed ? <Icon icon="brokenPicture" color="iconFade" /> : null}
          {this.state.loadFailed && this.props.showMissingLabel ? <span>Image not found</span> : null}
        </div>
      </div>
    );
  }
}

Image.propTypes = {
  source: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  fill: PropTypes.bool,
  showMissingLabel: PropTypes.bool,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func
};

export default Image;
